import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const painPoints = ['Quieres generar ingresos online pero no sabes qué vender.', 'Sientes que no tienes experiencia suficiente.', 'Te gustaría monetizar tus redes sociales.', 'Ves personas vendiendo productos digitales pero no sabes cómo empezar.', 'Quieres crear una fuente de ingresos que no dependa de intercambiar tiempo por dinero.'];
export function PainPoints() {
  return <section className="py-20 px-6 bg-brand-bgDeep" data-id="element-37">
      <div className="max-w-4xl mx-auto" data-id="element-38">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-39">
          <h2 className="text-3xl md:text-5xl font-black uppercase text-brand-navy mb-4 leading-tight" data-id="element-40">
            ¿Te identificas <span className="text-brand-accent" data-id="element-41">con esto?</span>
          </h2>
        </motion.div>

        <div className="space-y-4 mb-12" data-id="element-42">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4 bg-white p-6 rounded-2xl shadow-sm border border-brand-cardDark/30" data-id="element-43">
              <XCircle className="w-6 h-6 text-brand-accent shrink-0 mt-0.5" data-id="element-44" />
              <p className="text-lg text-brand-text/90 font-medium" data-id="element-45">{point}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} className="text-center" data-id="element-46">
          <p className="text-xl md:text-2xl font-serif italic text-brand-accent font-semibold" data-id="element-47">
            Si respondiste sí a alguna de estas preguntas, esta guía fue creada
            para ti.
          </p>
        </motion.div>
      </div>
    </section>;
}